import { useEffect, useState } from "react";
import { FaArrowRight, FaPhoneAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
import prod1 from "../../assets/Product_img/home/1.jpg";
import prod2 from "../../assets/Product_img/home/2.jpg";
import prod4 from "../../assets/Product_img/home/3.jpg";
import prod5 from "../../assets/Product_img/home/4.jpg";

const images = [
  prod1,
  prod2, prod4, prod5
];

export const Hero = (props: any) => {
  const [index, setIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setIndex((prev) => (prev + 1) % images.length);
        setFade(true);
      }, 600);
    }, 5500);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <section className="relative sm:h-screen md:h-[600px] w-full overflow-hidden mt-[85px]">
        {/* Background Image */}
        <div
          className={`absolute inset-0 bg-cover bg-top transition-all duration-[1200ms] ${fade ? "opacity-100 scale-100" : "opacity-0 scale-105"
            }`}

          style={{
            backgroundImage: `url(${images[index]})`,
          }}
        />

        {/* Animations */}
        <style>{`
        .animate-fade-slide {
          animation: fadeSlide 1.3s ease forwards;
        }
        .animate-fade-delay {
          animation: fadeUp 1.6s ease forwards;
        }
        @keyframes fadeSlide {
          0% { opacity: 0; transform: translateY(20px); }
          100% { opacity: 1; transform: translateY(0); }
        }
        @keyframes fadeUp {
          0% { opacity: 0; transform: translateY(30px); }
          100% { opacity: 1; transform: translateY(0); }
        }
      `}</style>
      </section>
      <section className="relative sm:h-[200px] md:h-[300px] flex items-center justify-center">

        {/* Gradient Overlay */}
        <div className="absolute inset-0 "></div>

        {/* HERO CONTENT */}
        <div className="relative z-10 flex flex-col items-center h-full text-center p-[50px] gap-y-10">
          <h1 className="text-white text-3xl sm:text-4xl md:text-6xl font-extrabold tracking-wide leading-snug drop-shadow-xl animate-fade-slide">
            <span className="text-gray-500">{props.titleOne}</span>  <br />
            <span className="text-red-500"> {props.titleTwo}</span>
          </h1>
          <p className="font-workSans sm:text-lg md:text-xl">{props.description}</p>

          {/* CTA Buttons */}
          <div className=" flex flex-col sm:flex-row gap-4 sm:gap-5 animate-fade-delay font-workSans">
            <Link to={"/products"} className="px-8 sm:px-10 py-3 sm:py-4 bg-red-600 text-white font-semibold rounded-xl shadow-lg flex items-center gap-2 sm:gap-3 text-base sm:text-lg transition-all duration-300 hover:bg-red-700 hover:shadow-red-500/40 hover:shadow-xl active:scale-95 group">
              {props.primaryCta}
              <FaArrowRight className="group-hover:translate-x-1 transition" />
            </Link>

            <Link to={"/quote#quote-form"} className="px-8 sm:px-10 py-3 sm:py-4 bg-white/90 text-gray-900 font-semibold rounded-xl shadow-lg flex items-center gap-2 sm:gap-3 text-base sm:text-lg backdrop-blur-sm hover:bg-white hover:shadow-xl hover:shadow-gray-300/40 transition-all duration-300 active:scale-95 group">
              {props.secondaryCta}
              <FaPhoneAlt className="group-hover:scale-110 transition" />
            </Link>
          </div>
        </div>

      </section>
    </>
  );
};
